const STATUS_TO_THEME = {
  success: { 
    textClass: "text-success-dark", 
    bgClass: "bg-success-light",
    bgColor: "#E4fbed", // Light green background (more pastel, matching image)
    textColor: "#24c25e" // Dark green text (softer green)
  },
  failed: { 
    textClass: "text-error-dark", 
    bgClass: "bg-error-light",
    bgColor: "#FFEBEE", // Light red background
    textColor: "#DC3545" // Dark red text
  },
  warning: { 
    textClass: "text-warning-dark", 
    bgClass: "bg-warning-light",
    bgColor: "#FFF4E6", // Light orange background
    textColor: "#FF8100" // Orange text
  },
  default: { 
    textClass: "text-foreground", 
    bgClass: "bg-muted",
    bgColor: "#F5F5F5", // Light gray background
    textColor: "#424242" // Dark gray text
  },
  error: { 
    textClass: "text-error-dark", 
    bgClass: "bg-error-light",
    bgColor: "#FFEBEE", // Light red background
    textColor: "#DC3545" // Dark red text
  },
  // Solid blue pill for Active
  active: { 
    textClass: "text-info-foreground", 
    bgClass: "bg-primary",
    bgColor: "#E3F2FD", // Light blue background
    textColor: "#1565C0" // Dark blue text
  },
  // common extras
  info: { 
    textClass: "text-info-dark", 
    bgClass: "bg-info-light",
    bgColor: "#E3F2FD", // Light blue background (matching the image)
    textColor: "#1565C0" // Dark blue text (matching the image)
  },
  primary: { 
    textClass: "text-primary-foreground", 
    bgClass: "bg-primary/10",
    bgColor: "#E3F2FD", // Light blue background
    textColor: "#1565C0" // Dark blue text
  },
  secondary: { 
    textClass: "text-secondary-foreground", 
    bgClass: "bg-secondary/10",
    bgColor: "#F5F5F5", // Light gray background
    textColor: "#424242" // Dark gray text
  },
  inactive: { 
    textClass: "text-inactive-dark", 
    bgClass: "bg-inactive-light",
    bgColor: "#F5F5F5", // Light gray background
    textColor: "#7E8299" // Gray text
  },
  neutral: { 
    textClass: "text-neutral-foreground", 
    bgClass: "bg-neutral/50", 
    borderClass: "border border-neutral-border",
    bgColor: "#F5F5F5", // Light gray background
    textColor: "#424242" // Dark gray text
  },
  scheduled: {
    textClass: "text-info-dark", 
    bgClass: "bg-info-light",
    bgColor: "#E3F2FD", // Light blue background (matching the image)
    textColor: "#1565C0" // Dark blue text (matching the image)
  },
  pending: {
    textClass: "text-warning-dark", 
    bgClass: "bg-warning-light",
    bgColor: "#FFF4E6", // Light orange background
    textColor: "#FF8100" // Orange text
  },
};

export function getStatusColors(status) {
  return STATUS_TO_THEME[status] || STATUS_TO_THEME.default;
}

export function getStatusTitle(status) {
  if (status === "info") return "Information";
  return status.charAt(0).toUpperCase() + status.slice(1);
}